import { useEffect } from "react";
import { LuCircleCheck } from "react-icons/lu";
import { LOCAL_STORAGE_KEYS } from "../../config/local_storage_keys";
import { trackEvent, trackPageview } from "../../utils/analyticsUtils";
import { PremiumFullscreenLayout } from "../common_components/PremiumFullscreenLayout";
import { colors, typography } from "../../design/tokens";

export default function SubscriptionsSuccessPage() {
  const handleGoBackToApp = () => {
    const returnUrl = localStorage.getItem(
      LOCAL_STORAGE_KEYS.SUBSCRIPTIONS_MODAL_RETURN_URL
    );
    localStorage.removeItem(LOCAL_STORAGE_KEYS.SUBSCRIPTIONS_MODAL_RETURN_URL);

    window.location.replace(returnUrl || "/");
  };

  useEffect(() => {
    trackPageview("Payment Success");
    trackEvent("purchase");
  }, []);

  return (
    <PremiumFullscreenLayout>
      <div
        className={`flex flex-col items-center justify-center gap-4 ${colors.surface.secondary} p-10 rounded-lg shadow-xl`}
      >
        <LuCircleCheck size={56} className="text-green-500" />
        <p
          className={`${typography.size.lg} text-center`}
          style={{ color: colors.hex.white }}
        >
          Your payment has been processed successfully
        </p>
        <button
          onClick={handleGoBackToApp}
          className={`bg-primary-blue ${typography.weight.semibold} ${typography.size.sm}
          py-2 px-4 rounded-full mt-5
          hover:opacity-90 transition-opacity duration-300
          flex items-center justify-center gap-2`}
          style={{ color: colors.hex.white }}
        >
          Go back to app
        </button>
      </div>
    </PremiumFullscreenLayout>
  );
}
